import { IAddress, ICartProps, ICustomerInfo } from '../../contexts/CartContext/CartContext.types';
import {
    ICreateAndPopulateCartRequest,
    ICreateCustomerRequest,
    IIdiAddress
} from './Idi.api.types';

export const MapCustomerInfoToCreateRequest = (
    customerInfo: ICustomerInfo
): ICreateCustomerRequest => {
    return {
        dateOfBirth: new Date(customerInfo.dob),
        emailAddress: customerInfo.emailAddress,
        firstName: customerInfo.firstName,
        lastName: customerInfo.lastName,
        phoneNumber: customerInfo.phoneNumber,
        serviceAddress: MapIdiAddress(customerInfo.address),
        billingAddressIsSameAsPrimary: !customerInfo.isDifferentBillingAddress,
        billingAddress: customerInfo.isDifferentBillingAddress
            ? MapIdiAddress(customerInfo.billingAddress?.address)
            : undefined,
        billingFirstName: customerInfo.isDifferentBillingAddress
            ? customerInfo.billingAddress?.firstName
            : undefined,
        billingLastName: customerInfo.isDifferentBillingAddress
            ? customerInfo.billingAddress?.lastName
            : undefined,
        billingDateOfBirth:
            customerInfo.isDifferentBillingAddress && customerInfo.billingAddress
                ? new Date(customerInfo.billingAddress.dob)
                : undefined,
        socialSecurityNumber: ''
    };
};

export const MapIdiAddress = (address?: IAddress): IIdiAddress | undefined => {
    if (!address) return undefined;

    return {
        addressLine1: address.addressLine1,
        addressLine2: address.addressLine2,
        city: address.city,
        state: address.state,
        zipcode: address.zipcode
    };
};

export const MapCreateCartRequest = (cart: ICartProps): ICreateAndPopulateCartRequest => {
    const createRequest: ICreateAndPopulateCartRequest = {
        customerId: cart.customerInfo.customerId,
        cart: {
            isOvernightShipping: cart.shippingMethod.overnight,
            phoneNumberReservationId: cart.reserveNumberResponse.reservationId.toString(),
            lineItems: [],
            accessories: [],
            customerAddress: cart.customerInfo.address
        }
    };

    cart.lineItems.forEach((l) => {
        const productBaseSkus =
            l.device?.product.baseSkus.filter(
                (s) => !s.timeZone || s.timeZone === cart.closestStoreTimeZone
            ) ?? [];

        createRequest.cart.lineItems.push({
            downPayment: l.device?.downPayment ?? 0,
            assuranceSku: l.device?.useAssurance
                ? (l.device.assuranceSku?.sku ?? 'FEAT_NO_ASP')
                : 'FEAT_NO_ASP',
            baseProductSkus: productBaseSkus.map((b) => b.sku) ?? [],
            byod: l.byod !== undefined,
            isPrimaryLine: l.isPrimaryLine,
            numberOfInstallments: l.device?.useRetailPrice
                ? 0
                : (l.device?.product.pricing.numMonths ?? 36),
            planSkus:
                l.planSelection?.plan.baseSkus
                    .map((b) => b.sku)
                    .concat(l.planSelection?.planSku.sku.sku)
                    .filter((p) => p) ?? [],
            productSku: l.device?.productSku?.sku.sku ?? '',
            serviceNumber: ''
        });
    });

    for (let x = 0; x < cart.reserveNumberResponse.reservationItems.length; x++) {
        createRequest.cart.lineItems[x].serviceNumber =
            cart.reserveNumberResponse.reservationItems[x].inventoryItem;
    }

    return createRequest;
};
